export default __webpack_public_path__ + "static/media/token_commit.61717af5.png";